<template>
  <b-modal v-model="visible" size="lg" :title="$t('people_failures_title')" hide-footer>
    <div v-if="loading" class="people-loading">
      <b-spinner small /> {{ $t('people_loading') }}
    </div>
    <div v-else-if="failures.items.length === 0" class="people-empty">
      {{ $t('people_no_failures') }}
    </div>
    <div v-else class="failure-list">
      <article v-for="failure in failures.items" :key="failure.id">
        <div>
          <strong>{{ $t('people_job') }} #{{ failure.id }}</strong>
          <span>
            {{ $t('people_attempts') }}: {{ failure.attempts }} ·
            {{ formatDuration(failure.duration_ms) }}
          </span>
        </div>
        <code>{{ failure.last_error }}</code>
      </article>
      <b-button
        v-if="failures.total > failures.items.length"
        variant="outline-light"
        @click="$emit('load-more')"
      >
        {{ $t('people_load_more') }}
      </b-button>
    </div>
    <div v-if="failures.total" class="failure-actions">
      <b-button variant="primary" @click="$emit('retry')">{{ $t('people_retry_failed') }}</b-button>
    </div>
  </b-modal>
</template>

<script>
import formatDuration from './formatDuration.js'

export default {
  props: {
    value: { type: Boolean, required: true },
    loading: { type: Boolean, required: true },
    failures: { type: Object, required: true },
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  methods: {
    formatDuration,
  },
}
</script>

<style scoped>
.people-loading,
.people-empty {
  padding: 5rem 1rem;
  color: var(--faded-text-color);
  text-align: center;
}

.failure-list {
  display: grid;
  gap: .75rem;
}

.failure-list article {
  display: grid;
  gap: .5rem;
  padding: .85rem;
  border: 1px solid rgba(127, 127, 127, .22);
  border-radius: 9px;
}

.failure-list article > div {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
}

.failure-list article span {
  color: var(--faded-text-color);
  font-size: .8rem;
}

.failure-list code {
  color: inherit;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
}

.failure-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 1rem;
}
</style>
